var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_328_3116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8336 2.40337C11.0205 2.61528 9.3005 3.32121 7.86132 4.44409C6.42214 5.56698 5.3191 7.06366 4.67262 8.77075C4.02614 10.4778 3.86107 12.3297 4.19541 14.1243C4.52976 15.9188 5.35068 17.587 6.56856 18.9467L11.6669 24.605C11.9622 24.9306 12.3223 25.1908 12.7242 25.3689C13.126 25.5469 13.5607 25.6389 14.0002 25.6389C14.4398 25.6389 14.8744 25.5469 15.2763 25.3689C15.6781 25.1908 16.0383 24.9306 16.3336 24.605L21.4086 18.9467C22.7512 17.4382 23.6043 15.5577 23.8552 13.5539C24.106 11.5501 23.7428 9.51737 22.8135 7.72446C21.8841 5.93156 20.4325 4.46295 18.6505 3.51283C16.8685 2.56271 14.8402 2.17584 12.8336 2.40337ZM14.0002 16.1467C13.2203 16.1467 12.4579 15.9154 11.8094 15.4821C11.161 15.0488 10.6555 14.433 10.3571 13.7124C10.0586 12.9919 9.98051 12.199 10.1327 11.4341C10.2848 10.6691 10.6604 9.96649 11.2119 9.41501C11.7634 8.86352 12.466 8.48796 13.2309 8.3358C13.9959 8.18365 14.7887 8.26174 15.5093 8.5602C16.2298 8.85866 16.8457 9.36409 17.279 10.0126C17.7123 10.661 17.9436 11.4235 17.9436 12.2034C17.9436 13.2492 17.5281 14.2522 16.7886 14.9917C16.0491 15.7312 15.0461 16.1467 14.0002 16.1467Z",
    fill: "#FF3D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_328_3116",
    x: 0.0268555,
    y: 2.33984,
    width: 27.9058,
    height: 31.2991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_328_3116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_328_3116",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocation);
export default __webpack_public_path__ + "static/media/geolocation.823d303f2ce8d9184cc9549a4483976b.svg";
export { ForwardRef as ReactComponent };